module.exports = __webpack_public_path__ + "static/media/Step6.c4cdb8d8.png";